<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <div class="personal-details" *ngIf="!isEditComposition">
          <h4 class="personal-details-title">Formula List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Formula Name</th>
                <th scope="col">No. of Products</th>
                <th scope="col">Total Amount</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of productCompositioncList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{product.productName}}</th>
                <th scope="col">{{product.productCompositionIngList.length}}</th>
                <th scope="col">{{product.price}}</th>
                <th>
                  <i class="bi bi-pencil-square" (click)="editComposition(product.productCompositionId)"></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="productCompositioncList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>

        <div class="personal-details" *ngIf="isEditComposition">
          <h4 class="personal-details-title">Edit Composition</h4>
          <div cdkDropListGroup class="composition-block">
            <div class="example-container-left">
              <h2>Raw Material</h2>
          
              <div
                cdkDropList
                [cdkDropListData]="cProductList"
                class="example-list1"
                (cdkDropListDropped)="drop($event)">
                <div class="example-box1" *ngFor="let item of cProductList" cdkDrag>{{item.name}}</div>
              </div>
            </div>
          
            <div class="example-container-right">
              <h2>Formula Name</h2>
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <input type="text" placeholder="enter formula name" [(ngModel)]="productName" class="form-control">
                </div>
                <div class="col-md-2 col-lg-2">
                  <input type="text" placeholder="batch quantity" class="form-control" [(ngModel)]="batchQuantity">
                </div>
                <div class="col-md-2 col-lg-2">
                  <input type="text" placeholder="batch price" class="form-control" [(ngModel)]="batchPrice">
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group ">
                    <ng-multiselect-dropdown
                    [placeholder]="'select uoms'"
                    [settings]="uomDropdownSettings"
                    [data]="uomDropdownList"
                    [(ngModel)]="uomSelectedList"
                    class="form-control"
                    style="padding: 0;border: none"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                    >
                    </ng-multiselect-dropdown>
                  </div>                     
                </div>
                <div class="col-md-4 col-lg-4" *ngIf="uomSelectedList.length != 0">
                  <select class="form-control" [(ngModel)]="isDefault">
                    <option value="" disabled selected hidden>-- select default uom --</option>
                    <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                  </select>
                </div>
              </div>
         

              <div
                cdkDropList
                [cdkDropListData]="done"
                class="example-list"
                (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of done" cdkDrag>
                  <div class="row input-data">
                    <div class="col-md-12 col-lg-12">
                      <!-- <label for="">Product:</label> -->
                      <p>{{item.name}}</p>
                    </div>
                    <!-- <div class="col-md-6 col-lg-6">
                      <label for="">Price:</label>
                      <p>{{item.price}}</p>
                    </div> -->
                    <div class="col-md-2 col-lg-2">
                      <label for="">Price:</label>
                      <input type="text" readonly class="form-control" value="{{item.price}}">
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <label for="">UOM:</label>
                      <select class="form-control" [(ngModel)]="item.uom">
                        <option value="" disabled selected hidden>-- select uom --</option>
                        <option *ngFor="let uom of uomData" [value]="uom.uomName">{{uom.uomName}}</option>
                      </select>
                    </div>
                  
                    <div class="col-md-2 col-lg-2">
                      <label for="">Quantity:</label>
                      <input type="number" class="form-control" (keyup)="amountChanged()" [(ngModel)]="item.qty">
                    </div>

                    <div class="col-md-2 col-lg-2">
                      <label for="">Sub Total:</label>
                      <input readonly type="text" class="form-control" value="{{item.price * item.qty}}">
                    </div>
                  </div>
                </div>
              </div>
              <div class="submit-footer">
                <p>Amount: {{amount}}</p>
                <div>
                  <!-- <button class="view-b" data-toggle="modal" data-target="#viewModal">view</button> -->
                  <button class="btn btn-secondary" (click)="closeEdit()">Cancel</button>

                  <button class="add-b" (click)="editCProduct()">submit</button>
                </div>
              </div>
            </div>
        </div>
      </div>
      </div>
    </div>
</div>


<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prodcut Composition
          <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let product of singleproductCompositionData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Name</label>
                <input type="text" readonly value="{{product.productName}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Price</label>
                <input type="text" readonly value="{{product.batchPrice}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Quantity</label>
                <input type="text" readonly value="{{product.batchQuantity}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Total Amount</label>
                <input type="text" readonly value="{{product.totalAmount}}" class="form-control">
              </div>
            </div>
          </div>
          <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 60%;">Product</th>
                <th style="width: 10%;text-align: center;">Uom</th>
                <th style="width: 10%;text-align: center;">Quantity</th>
                <th style="width: 10%;text-align: center;">Price</th>
                <th style="width: 10%;text-align: center;">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let productCompositionIngList of product.productCompositionIngList;let i = index">
                <th>{{productCompositionIngList.name}}</th>
                <th style="text-align: center;">{{productCompositionIngList.uom}}</th>
                <th style="text-align: center;">{{productCompositionIngList.qty}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price * productCompositionIngList.qty}}</th>
              </tr>    
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>